import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

import { MutualModule } from '@shared/mutual/mutual.module';
import { IdentifierQualifierUpdateComponent, IdentifierEntityUpdateComponent, IdentifierHiddenControlComponent } from './components';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

@NgModule({
  imports: [CommonModule, MutualModule, BsDatepickerModule, PipesSharedModule],
  declarations: [IdentifierEntityUpdateComponent, IdentifierQualifierUpdateComponent, IdentifierHiddenControlComponent],
  exports: [IdentifierEntityUpdateComponent, IdentifierQualifierUpdateComponent, IdentifierHiddenControlComponent],
})
export class IdentifierUpdateModule {}
